import { createEpic } from "../helpers";

import {
	getSeasonalUniquePlayersAsyncAction,
	getDashboardAsyncAction,
	changeUserChartAction,
	changeOnlineTourAction,
	changeOfflineTourAction,
} from "./dashboardActions";

export const getDashboardEpic = createEpic(
	getDashboardAsyncAction,
	"dashboard",
	"getList",
	true
);

export const getSeasonalUniquePlayersEpic = createEpic(
	getSeasonalUniquePlayersAsyncAction,
	"dashboard",
	"getSeasonalUniquePlayers",
	true
);

export const getDashboardUserChartEpic = createEpic(
	changeUserChartAction,
	"dashboard",
	"changeUserChart",
	true
);

export const getDashboardOnlineTourEpic = createEpic(
	changeOnlineTourAction,
	"dashboard",
	"changeOnlineTourChart",
	true
);

export const getDashboardOfflineTourEpic = createEpic(
	changeOfflineTourAction,
	"dashboard",
	"changeOfflineTourChart",
	true
);
